import React from 'react';
import './LeaderboardTable.scss';
const LeaderboardTable = ({
  columns,
  data,
  headerStyle
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "LeaderboardTable"
  }, /*#__PURE__*/React.createElement("table", {
    role: "table"
  }, /*#__PURE__*/React.createElement("thead", {
    style: headerStyle
  }, /*#__PURE__*/React.createElement("tr", {
    role: "row",
    style: headerStyle
  }, columns.map((column, headerIndex) => /*#__PURE__*/React.createElement("th", {
    className: column.headerClassName,
    style: headerStyle,
    key: headerIndex
  }, column.Header)))), /*#__PURE__*/React.createElement("tbody", null, data.map((row, rowIndex) => {
    return /*#__PURE__*/React.createElement("tr", {
      key: rowIndex
    }, columns.map((col, colIndex) => {
      const parseValue = col.Cell ? col.Cell(row) : row[col.accessor];
      return /*#__PURE__*/React.createElement("td", {
        key: colIndex,
        className: col.rowClassName
      }, parseValue);
    }));
  }))));
};
export default LeaderboardTable;